module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-right-57e9cd5f.svg";